// Клиентское применение SEO (BrowserRouter не поддерживает useMatches для 404 — страница NotFound вызывает это отдельно).

export const SITE_URL = 'https://www.reshai.xyz';
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/hero.jpg`;
export const OG_IMAGE_DIR = `${SITE_URL}/images/og/`;
export const SITE_LOGO_URL = `${SITE_URL}/favicon-light.svg`;

export function getOgImageForPath(pathname) {
  const p = (pathname || '').trim();
  if (!p || p === '/') return `${OG_IMAGE_DIR}og-home.png`;
  return DEFAULT_OG_IMAGE;
}

function upsertMeta(name, content, attr = 'name') {
  if (!content) return;
  let tag = document.head.querySelector(`meta[${attr}="${name}"]`);
  if (!tag) {
    tag = document.createElement('meta');
    tag.setAttribute(attr, name);
    document.head.appendChild(tag);
  }
  tag.setAttribute('content', content);
}

function setAlternateLinks(canonicalUrl) {
  document.head.querySelectorAll('link[data-seo-alternate="true"]').forEach((node) => node.remove());
  const alternates = [
    { hreflang: 'ru-RU', href: canonicalUrl },
    { hreflang: 'x-default', href: canonicalUrl },
  ];
  alternates.forEach(({ hreflang, href }) => {
    const link = document.createElement('link');
    link.setAttribute('rel', 'alternate');
    link.setAttribute('hreflang', hreflang);
    link.setAttribute('href', href);
    link.setAttribute('data-seo-alternate', 'true');
    document.head.appendChild(link);
  });
}

/** Мета и JSON-LD для 404 (вызывается из NotFound после SeoManager). */
export const NOT_FOUND_SEO = {
  title: 'Страница не найдена — РешAI',
  description:
    'Запрошенная страница не существует. Вернитесь на главную РешAI или выберите раздел сайта.',
  robots: 'noindex,nofollow',
  canonical: `${SITE_URL}/`,
  type: 'website',
};

/**
 * Применяет мета-теги, canonical и JSON-LD для текущего маршрута.
 * @param {object} seo — title, description, robots, canonical, type?, jsonLd?
 * @param {string} pathname — для og:image по пути
 */
export function applyClientSeo(seo, pathname) {
  const ogImage = getOgImageForPath(pathname);
  document.title = seo.title;
  upsertMeta('description', seo.description);
  upsertMeta('robots', seo.robots);
  upsertMeta('og:title', seo.title, 'property');
  upsertMeta('og:description', seo.description, 'property');
  upsertMeta('og:type', seo.type || 'website', 'property');
  upsertMeta('og:url', seo.canonical, 'property');
  upsertMeta('og:site_name', 'РешAI', 'property');
  upsertMeta('og:image', ogImage, 'property');
  upsertMeta('og:image:alt', 'РешAI — подготовка к ЕГЭ с ИИ', 'property');
  upsertMeta('twitter:card', 'summary_large_image');
  upsertMeta('twitter:title', seo.title);
  upsertMeta('twitter:description', seo.description);
  upsertMeta('twitter:image', ogImage);

  let canonical = document.head.querySelector('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.setAttribute('rel', 'canonical');
    document.head.appendChild(canonical);
  }
  canonical.setAttribute('href', seo.canonical);
  setAlternateLinks(seo.canonical);

  const organizationSchema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: 'РешAI',
    url: SITE_URL,
    logo: SITE_LOGO_URL,
    sameAs: [
      'https://t.me/reshai_official',
      'https://youtube.com/@reshai_official',
      'https://tiktok.com/@reshai_official',
    ],
    areaServed: 'RU',
  };

  const schemas = [organizationSchema];
  if (Array.isArray(seo.jsonLd)) {
    schemas.push(...seo.jsonLd);
  } else if (seo.jsonLd) {
    schemas.push(seo.jsonLd);
  }

  let ld = document.getElementById('reshai-jsonld');
  if (!ld) {
    ld = document.createElement('script');
    ld.setAttribute('type', 'application/ld+json');
    ld.setAttribute('id', 'reshai-jsonld');
    document.head.appendChild(ld);
  }
  ld.textContent = JSON.stringify(schemas);
}
